import {message as t} from '../../utils/messages';
import {CurrencyOptionEnum} from '../enumerations';

export const CurrencyOptionList = [
  {
    label: t('currency-local'),
    value: CurrencyOptionEnum.local,
  },
  {
    label: t('currency-foreign'),
    value: CurrencyOptionEnum.foreign,
  },
];
